import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=b0bfe46c&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=b0bfe46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bfe46c",
  null
  
)

/* custom blocks */
import block0 from "./BaseAlert.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports